var render = function render(){var _vm=this,_c=_vm._self._c;return _c('validation-observer',{ref:"formValidator",attrs:{"slim":""},scopedSlots:_vm._u([{key:"default",fn:function({}){return [_c('form',{key:"formPage",attrs:{"role":"form"},on:{"submit":function($event){$event.preventDefault();return _vm.performSubmit()}}},[_vm._t("default")],2)]}}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }